import Vue from "vue";
import CookieLaw from "vue-cookie-law";

Vue.component("CookieLaw", CookieLaw);
